import { render, staticRenderFns } from "./CooperativeMachines.vue?vue&type=template&id=97560d94&scoped=true&"
import script from "./CooperativeMachines.vue?vue&type=script&lang=js&"
export * from "./CooperativeMachines.vue?vue&type=script&lang=js&"
import style0 from "./CooperativeMachines.vue?vue&type=style&index=0&id=97560d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97560d94",
  null
  
)

export default component.exports